import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_2 = { class: "font-bold text-gray-900 text-lg mb-4" }
const _hoisted_3 = { class: "font-bold text-gray-900" }
const _hoisted_4 = { class: "divide-y text-sm text-gray-iron-700" }
const _hoisted_5 = { class: "font-bold text-gray-900" }
const _hoisted_6 = { class: "divide-y text-sm text-gray-iron-700" }

import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';

import ColoredText from '../components/ColoredText.vue';
import DefaultChip from '../components/DefaultChip.vue';
import FinancingSegmentView from '../components/FinancingSegmentView.vue';
import CustomerProfileDisplay from '../components/CustomerProfileDisplay.vue';

import { useCurrentEstimatedSegments } from '../composables/useCurrentEstimatedSegments';


export default /*@__PURE__*/_defineComponent({
  __name: 'SegmentsSummary',
  setup(__props) {

const { financingSegments, regularSegments } = useCurrentEstimatedSegments();

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CustomerProfileDisplay),
    (_unref(financingSegments).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(financingSegments), (segment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `financing-${segment.id}`
            }, [
              _createElementVNode("h2", _hoisted_2, "Podsumowanie " + _toDisplayString(segment.name), 1),
              _createVNode(FinancingSegmentView, {
                segment: segment as any
              }, null, 8, ["segment"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Accordion), {
      value: [0],
      multiple: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regularSegments), (segment, index) => {
          return (_openBlock(), _createBlock(_unref(AccordionPanel), {
            class: "mb-3",
            value: index,
            key: segment.id
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AccordionHeader), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, "Podsumowanie " + _toDisplayString(segment.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(AccordionContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segment.rules, (rule) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: rule.id,
                        class: "flex items-center justify-between py-3.5"
                      }, [
                        _createVNode(ColoredText, {
                          variant: rule.color
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(rule.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant"]),
                        _withDirectives((_openBlock(), _createBlock(DefaultChip, {
                          variant: rule.color
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(rule.eval) + " " + _toDisplayString(rule.unit), 1)
                          ]),
                          _: 2
                        }, 1032, ["variant"])), [
                          [
                            _directive_tooltip,
                            rule.expression,
                            void 0,
                            { left: true }
                          ]
                        ])
                      ]))
                    }), 128))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segment.groups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.id,
                      class: "space-y-1"
                    }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(group.name), 1),
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rules, (groupRule) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: groupRule.id,
                            class: "flex items-center justify-between py-3.5"
                          }, [
                            _createVNode(ColoredText, {
                              variant: groupRule.color,
                              class: "max-w-40 text-sm"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(groupRule.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["variant"]),
                            _withDirectives((_openBlock(), _createBlock(DefaultChip, {
                              variant: groupRule.color
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(groupRule.eval) + " " + _toDisplayString(groupRule.unit), 1)
                              ]),
                              _: 2
                            }, 1032, ["variant"])), [
                              [
                                _directive_tooltip,
                                groupRule.expression,
                                void 0,
                                { left: true }
                              ]
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})